import {combineReducers} from 'redux';

import type {UpdateDefaultStagesetForOnboardingWizardInputFieldInput} from 'nutshell-graphql-types';

import type {ActiveItem} from './types';
import {ActionTypes as UiActionTypes} from './ui-actions';
import type {SalesAutomationUiAction} from './ui-actions';

// This reducer is responsible for ui-level concerns, such as which tab
// is selected, is the form open, etc.

type ActiveItemState = SalesAutomationUiState['activeItem'];
export const activeItem = (
    state: ActiveItemState | null | undefined = null,
    action: SalesAutomationUiAction
): ActiveItemState => {
    switch (action.type) {
        case UiActionTypes.SALES_AUTOMATION_ACTIVE_ITEM_SET:
            return action.payload;
        case UiActionTypes.SALES_AUTOMATION_ACTIVE_ITEM_CLEARED:
            return null;
        default:
            return state;
    }
};

type HoveredStageIdState = SalesAutomationUiState['hoveredStageId'];
export const hoveredStageId = (
    state: HoveredStageIdState | null | undefined = null,
    action: SalesAutomationUiAction
): HoveredStageIdState => {
    switch (action.type) {
        case UiActionTypes.SALES_AUTOMATION_HOVERED_STAGE_SET:
            return action.payload;
        default:
            return state;
    }
};

type IsSidebarFormSavingState = SalesAutomationUiState['isSidebarFormSaving'];
export const isSidebarFormSaving = (
    state: IsSidebarFormSavingState | null | undefined = false,
    action: SalesAutomationUiAction
): IsSidebarFormSavingState => {
    switch (action.type) {
        case UiActionTypes.SALES_AUTOMATION_SIDEBAR_FORM_SAVE_STATUS_SET:
            return action.payload;
        case UiActionTypes.SALES_AUTOMATION_ACTIVE_ITEM_CLEARED:
            return false;
        default:
            // @ts-expect-error
            return state;
    }
};

type CollapsedSectionsState = SalesAutomationUiState['collapsedSections'];
const collapsedSections = (
    state: CollapsedSectionsState | null | undefined = [],
    action: SalesAutomationUiAction
): CollapsedSectionsState => {
    switch (action.type) {
        case UiActionTypes.SALES_AUTOMATION_SECTION_EXPANSION_TOGGLED: {
            const sectionType = action.payload;

            // @ts-expect-error
            return state.includes(sectionType)
                ? // @ts-expect-error
                  state.filter((sectionName) => sectionName !== sectionType)
                : // @ts-expect-error
                  state.concat([sectionType]);
        }

        default:
            // @ts-expect-error
            return state;
    }
};

type OnboardingWizzardState = SalesAutomationUiState['onboardingWizard'];
const onboardingWizard = (
    state: OnboardingWizzardState | null | undefined = {},
    action: SalesAutomationUiAction
): OnboardingWizzardState => {
    switch (action.type) {
        case UiActionTypes.SALES_AUTOMATION_ONBOARDING_OPTION_ADDED: {
            const option = action.payload;

            return {...state, [option]: true};
        }
        case UiActionTypes.SALES_AUTOMATION_ONBOARDING_OPTION_REMOVED:
            return {...state, [action.payload]: false};
        default:
            // @ts-expect-error
            return state;
    }
};

export type SalesAutomationUiState = {
    collapsedSections: string[];
    activeItem: ActiveItem | null | undefined;
    hoveredStageId: string | null | undefined;
    isSidebarFormSaving: boolean;
    onboardingWizard: UpdateDefaultStagesetForOnboardingWizardInputFieldInput;
};

export const uiReducer = combineReducers({
    activeItem,
    hoveredStageId,
    collapsedSections,
    onboardingWizard,
    isSidebarFormSaving,
});
